export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getActivity: function getActivity(activityPublicID) {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivity', [activityPublicID]);
        },
        getActivitiesForUser: function getActivitiesForUser() {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForUser', []);
        },
        getActivitiesForPolicy: function getActivitiesForPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForPolicy', [policyNumber]);
        },
        getActivitiesForAccount: function getActivitiesForAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForAccount', [accountNumber]);
        },
        getActivitiesForJob: function getActivitiesForJob(submissionNumber) {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForJob', [submissionNumber]);
        },
        markActivityAsCompleted: function markActivityAsCompleted(activityPublicID) {
            return JsonRPCService.send('pc', 'gateway/activity', 'markActivityAsCompleted', [activityPublicID]);
        },
        getActivityNotes: function getActivityNotes(activityPublicId) {
            return JsonRPCService.send('pc', 'gateway/activity', 'getNotesForActivity', [activityPublicId]);
        },
        createNoteForActivity: function createNoteForActivity(activityPublicID, noteDTO) {
            return JsonRPCService.send('pc', 'gateway/activity', 'createNoteForActivity', [activityPublicID, noteDTO]);
        },
        getActivityPatternsFor: function getActivityPatternsFor(actPatternEntity) {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivityPatternsFor', [actPatternEntity]);
        },
        createNewActivity: function createNewActivity(activity, note) {
            return JsonRPCService.send('pc', 'gateway/activity', 'createNewActivity', [activity, note]);
        },
        getAssignableUserForActivity: function getAssignableUserForActivity(actPatternEntity, id, activityPattern) {
            return JsonRPCService.send('pc', 'gateway/activity', 'getAssignableUserForActivity', [actPatternEntity, id, activityPattern]);
        },
        reassignActivity: function reassignActivity(selectedUser, id) {
            return JsonRPCService.send('pc', 'gateway/activity', 'reassignActivity', [selectedUser, id]);
        },
        getActivitiesForCurrentUserAndGroups: function getActivitiesForCurrentUserAndGroups() {
            return JsonRPCService.send('pc', 'gateway/activity', 'getActivitiesForCurrentUserAndGroups', []);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/ActivityService.js
// module id = 1783
// module chunks = 0